import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { localCompareEnglish } from '@shared/utils/sorting-localcompare-util';

import { ProductOrderItem } from '../../models/order-request.model';
import { ItemPrice, getPriceFormat } from '../../utils/calculate-price-util';
import {
  OrderSelectiveSelectItemOrderActionTypes,
  OrderSelectiveSelectItemOrderActions
} from '../actions/order-selective-select-item.actions';

export interface OrderSelectiveSelectItemOrderState extends EntityState<ProductOrderItem> {
  isLoading: boolean;
  skipUpdated: boolean;
}

export function sortList(a: ProductOrderItem, b: ProductOrderItem) {
  const aProductName = a.productName;
  const bProductName = b.productName;

  return localCompareEnglish(aProductName, bProductName);
}

export const adapter: EntityAdapter<ProductOrderItem> = createEntityAdapter<ProductOrderItem>({
  selectId: (orderSelectItemOrderSelectiveContent: ProductOrderItem) =>
    orderSelectItemOrderSelectiveContent.articleNo,
  sortComparer: sortList
});

export const initialOrderSelectiveSelectItemOrderState: OrderSelectiveSelectItemOrderState = adapter.getInitialState({
  isLoading: false,
  skipUpdated: false
});

export function OrderSelectiveSelectItemOrderReducers(
  state = initialOrderSelectiveSelectItemOrderState,
  action: OrderSelectiveSelectItemOrderActions
): OrderSelectiveSelectItemOrderState {
  switch (action.type) {
    case OrderSelectiveSelectItemOrderActionTypes.ORDER_SELECTIVE_SELECT_ITEM_ORDER_ADD_ITEM:
      return adapter.upsertOne(action.payload, {
        ...state,
        skipUpdated: false
      });
    case OrderSelectiveSelectItemOrderActionTypes.ORDER_SELECTIVE_SELECT_ITEM_ORDER_UPDATE_ITEM:
      return adapter.updateOne(
        {
          id: action.payload.articleNo,
          changes: { ...action.payload }
        },
        {
          ...state,
          skipUpdated: false
        }
      );
    case OrderSelectiveSelectItemOrderActionTypes.ORDER_SELECTIVE_SELECT_ITEM_ORDER_UPDATE_ALL_ITEM:
      return adapter.updateMany(
        action.payload.map(v => {
          const item: ProductOrderItem = state.entities[v.articleNo];
          const itemPrice = new ItemPrice<ProductOrderItem>({ ...item, qty: v.qty }, 'qty');
          const amountExcVat = itemPrice.getTotalFrom('wholesalePriceExcVat');
          const vatAmount = itemPrice.getTotalFrom('vatAmount');
          const amount = getPriceFormat(amountExcVat.amount + vatAmount.amount);
          return {
            id: v.articleNo,
            changes: {
              ...item,
              qty: v.qty,
              amountExcVat,
              amount,
              totalVat: vatAmount,
              isAddItem: true
            }
          };
        }),
        {
          ...state,
          skipUpdated: false
        }
      );
    case OrderSelectiveSelectItemOrderActionTypes.ORDER_SELECTIVE_SELECT_ITEM_ORDER_ADD_ALL_ITEM:
      return adapter.upsertMany(action.payload.itemList, {
        ...state,
        skipUpdated: action.payload.skipUpdated
      });
    case OrderSelectiveSelectItemOrderActionTypes.ORDER_SELECTIVE_SELECT_ITEM_ORDER_REMOVE_ITEM:
      return adapter.removeOne(action.payload, {
        ...state
      });
    case OrderSelectiveSelectItemOrderActionTypes.ORDER_SELECTIVE_SELECT_ITEM_ORDER_RESET:
      return adapter.removeAll({
        ...state
      });
    default: {
      return state;
    }
  }
}

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
